import { FC, useMemo } from "react";

import {
  useBookingsNavigation,
  useBulkGridSelection,
  usePageContext,
} from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import { HeaderSelectedRowsToggle, HeaderStarredButton } from "../../elements";
import { HeaderBottomLeftControlsStyled } from "./header-bottom.styled";
import { UserUpdaterRideToggle } from "./user-updater-ride-toggle";

export const HeaderBottomLeftControls: FC = () => {
  const { entity } = usePageContext();
  const { isMobile, isNarrowMobile, isHeaderStarredRowCountHideViewport } =
    useIsMobile();
  const { showRowCountInput } = useBulkGridSelection();
  const { isCalendarBookingView } = useBookingsNavigation();

  const showUserUpdaterRideToggle = useMemo(() => {
    return entity === "ride";
  }, [entity]);

  const showStarredButton = useMemo(() => {
    if (entity === "report") {
      return false;
    }

    if (isNarrowMobile) {
      return false;
    }

    if (showRowCountInput && isHeaderStarredRowCountHideViewport) {
      return false;
    }

    return true;
  }, [
    entity,
    isNarrowMobile,
    showRowCountInput,
    isHeaderStarredRowCountHideViewport,
  ]);

  const showSelectedRowsToggle = useMemo(() => {
    if (entity === "report" || isCalendarBookingView) {
      return false;
    }

    if (isMobile && isNarrowMobile && showRowCountInput) {
      return false;
    }

    return true;
  }, [
    entity,
    isCalendarBookingView,
    isMobile,
    isNarrowMobile,
    showRowCountInput,
  ]);

  const displayCondition = useMemo(
    () =>
      Boolean(
        showStarredButton ||
        showUserUpdaterRideToggle ||
        showSelectedRowsToggle,
      ),
    [showStarredButton, showUserUpdaterRideToggle, showSelectedRowsToggle],
  );
  return (
    displayCondition && (
      <HeaderBottomLeftControlsStyled>
        {showStarredButton && <HeaderStarredButton />}
        {showSelectedRowsToggle && <HeaderSelectedRowsToggle />}
        {showUserUpdaterRideToggle && <UserUpdaterRideToggle />}
      </HeaderBottomLeftControlsStyled>
    )
  );
};
